/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InsuranceCarrier/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function InsuranceCarrier({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/Profile/InsurancePaymentAccount/Content/Content/InsuranceCarrier"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let insuredInsuranceSubscriptionInsurancePlanInsuranceBillingCenterNameValueData = fromData.useDataValue({ viewPath,
context: 'insured',
path: 'insurance_subscription.insurance_plan.insurance_billing_center.name',
})
let insuredInsuranceSubscriptionInsurancePlanInsuranceCompanyCarrierNameValueData = fromData.useDataValue({ viewPath,
context: 'insured',
path: 'insurance_subscription.insurance_plan.insurance_company.carrier_name',
})
let aggregateData = fromAggregate.any(insuredInsuranceSubscriptionInsurancePlanInsuranceBillingCenterNameValueData, insuredInsuranceSubscriptionInsurancePlanInsuranceCompanyCarrierNameValueData)
  return (<React.Fragment
>
<div
  data-testid="InsuranceCarrier.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Insurance Carrier"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="insured.insurance_subscription.insurance_plan.insurance_billing_center.name"
 data="insured.insurance_subscription.insurance_plan.insurance_company.carrier_name"
 aggregate="/Data/aggregate.js any"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}